import { TiDelete } from 'react-icons/ti';

export default function Pill({ 
    removable = false,
    onClick = () => {}, 
    onRemoveClick = () => {}, 
    children, 
    type = null, 
    state = null,
    cursorHover = false,
}) {
    type = type !== null ? `pill--${type}` : '';
    state = state !== null ? `pill-state--${state}` : '';
    cursorHover = cursorHover ? 'pill--hover' : '';

    return (
        <div className={`pill ${type} ${state} ${cursorHover}`} onClick={onClick} style={{ gap: '10px' }}>
            { children }
            { removable ? <TiDelete onClick={onRemoveClick} style={{ width: '16px', height: '16px' }}/> : '' }
        </div>
    )
}